import { useEffect, useState } from "react";
import Accordion from "react-bootstrap/Accordion";
import {
  Table,
  Modal,
  Form,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Row,
  Col,
} from "react-bootstrap";
import { format } from 'date-fns';
import MemberDetails from "../../ClaimIntimation/PolicyInfo/MemberDetails";
import TextTruncate from "../../../../utilsComponent/textTruncate";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "./claimIntimationDetail.scss";
import { getBasicSearchResults } from "../../ClaimIntimation/Search/apiHelper";
import { fetchAilmentTypes, fetchHospitalizationReasons } from "../../ClaimIntimation/ClaimForm/apiHelper";
import { FORM_KEYS, getAge, getHealthPolicyStatus, getPolicyMembers } from "../../ClaimIntimation/ClaimForm/helper";
import { fetchStates } from "../../../apiHelper";
import HospitalizationDetails from "../../ClaimIntimation/ClaimForm/HospitalizationDetails";
import { axiosRequest } from "../../../../service";
import { HEALTH_CLAIM_INGESTION, REACT_APP_KSHEMA_POC1, REACT_APP_VAM_ENDPOINT } from "../../../../urls";
import { toast } from "react-toastify";
import { editModeOn, getChannelName } from "../../../../utilFunctions";
import LoadingPage from "../../../../reusableComponents/loader/loadingPage";
import { DATE_FORMAT, functionalities, PAGE_NAME_KEYS } from "../../../../consts";
import { useLocation, useNavigate } from "react-router-dom";
import { getIsShowButton } from "../Service/apiHelper";

const ClaimIntimationDetail = ({ claimDetails, claimId, claimBasicDetails, getClaimDetails }) => {
  const {
    policyId,
    policy_status,
  } = claimDetails || {};

  const [loading, setLoading] = useState(false);
  const [policyData, setPolicyData] = useState(null);
  const [patientMemberDetails, setPatientMemberDetails] = useState({})

  useEffect(() => {
    getStatesList()
    getAilmentTypes()
    getHospitalizationReason()
  }, []);

  const getPolicyDetails = async () => {
    setLoading(true);
    const searchFields = {
      search_type: { value: "1" }, // we are keeping value 1 because we are searching with product name
      product_name: { label: claimBasicDetails?.productName },
      search_type_value: claimBasicDetails?.policyId,
    };
    try {
      const response = await getBasicSearchResults(searchFields, setLoading);
      if (response?.data && response.data !== "No Data Present") {
        setPolicyData(response?.data[0]);
      } else {
        setPolicyData([]);
      }
    } catch (error) {
      console.error("Failed to fetch data:", error);
      setPolicyData([]);
    }
  };
  useEffect(() => {
    getPolicyDetails()
  }, [claimDetails])

  const getHospitalizationReason = async () => {
    setLoading(true)
    const response = await fetchHospitalizationReasons()
    setLoading(false)
    setHospitalizationReasons(response)
  }
  const getStatesList = async () => {
    setLoading(true);
    const fetchedStates = await fetchStates()
    setLoading(false)
    setStatesList(fetchedStates);
  };
  const getAilmentTypes = async () => {
    setLoading(true)
    const response = await fetchAilmentTypes()
    setLoading(false)
    setAilmentList(response)
  }
  const [hospitalDetails, setHospitalDetails] = useState([])
  const defaultHospitalizationDetails = {
    [FORM_KEYS.date_of_admission]: null,
    [FORM_KEYS.time_of_admission]: null,
    [FORM_KEYS.date_of_discharge]: null,
    [FORM_KEYS.time_of_discharge]: null,
    [FORM_KEYS.pincode]: "",
    [FORM_KEYS.state]: null,
    [FORM_KEYS.district]: null,
    [FORM_KEYS.mandal]: null,
    [FORM_KEYS.village]: null,
    [FORM_KEYS.hospital]: null,
    [FORM_KEYS.hospital_name]: "",
    [FORM_KEYS.hospital_city_and_pincode]: null,
    [FORM_KEYS.icu_days]: "",
    [FORM_KEYS.non_icu_days]: "",
    [FORM_KEYS.doctor_name]: "",
    [FORM_KEYS.doctor_mobile_number]: "",
    [FORM_KEYS.doctor_registration_number]: "",
    [FORM_KEYS.reason_of_hospitalization]: "",
    [FORM_KEYS.ailment]: null,
    [FORM_KEYS.description_of_diagnosis]: "",
    hospitalizationId: ""
  }

  const claimDetailCookie = claimDetails;
  const {
    product_name,
    age,
    reasonForHospitalisation,
    claimCount,
    letters,
    proposalId,
    claimWarning,
    claimIntimatedBy,
    additionalRemarks,
    customer_ref_id,
    policyholder_dob,
    gender,
    communication_state,
    communication_district,
    communication_mandal,
    communication_village,
    communication_pincode,
    sum_insured,
    base_premium,
    igst,
    cgst,
    sgst,
    total_premium,
    policy_start_date,
    policy_end_date,
    policy_type,
    policy_doc_id,
    bank_name,
    account_number,
    ifsc_code,
    ckyc_kin_number,
    endorsementNumber,
    addOnCovers,
    insured_days,
    sum_insured_per_day,
    customer_name,
    customer_mobile,
    pre_exisiting_disease,
    policy_holder_details
  } = policyData || {};

  const defaultValues = {
    [FORM_KEYS.time_of_incidence]: null,
    hospitalizationDetails: [
      defaultHospitalizationDetails
    ],
  }
  const [formData, setFormData] = useState(defaultValues);
  const [hospitalizationReasons, setHospitalizationReasons] = useState([]);
  const [ailmentList, setAilmentList] = useState([]);
  const [statesList, setStatesList] = useState([]);
  const [isDisabled, setIsDisabled] = useState(false)
  const [hospitalizationDetails, setHospitalizationDetails] = useState(null);
  const [showAddModal, setShowAddModal] = useState(false)
  const [districtsList, setDistrictsList] = useState(null)
  const [editableFields, setEditableFields] = useState({
    dateOfDischarge: "",
    icuDays: "",
    nonIcuDays: "",
  });
  const [showAddHospital, setShowAddHospital] = useState(false);
  const [prevDischargeDate, setPrevDischargeDate] = useState("");
  const [prevDischargeTime, setPrevDischargeTime] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const getVillages = (hospitalDetails) => {
    const data = hospitalDetails ||hospitalizationDetails;
    const enrichedHospiData = data?.map(item => {
      const district = districtsList?.find(e => e.districtId === item.districtId);
      const village = district?.villages?.find(v => v.villageId === item.villageId);
      const location = village ? { ...village, districtName: district?.districtName } : null;
      return { ...item, location };
    });
    if (enrichedHospiData?.length) {
      setHospitalizationDetails(enrichedHospiData);
    }
  };


  useEffect(() => {
    if (districtsList?.length > 0 && hospitalizationDetails?.length) {
      getVillages();
    }
  }, [districtsList]);

  useEffect(() => {
    if (hospitalizationDetails?.length) {
      const show = shouldShowAddHospital()
      setShowAddHospital(show)
      if (show) {
        const lastHospital = hospitalizationDetails[hospitalizationDetails?.length-1];
        setPrevDischargeDate(lastHospital?.dischargeAt ? format(new Date(lastHospital?.dischargeAt), DATE_FORMAT.YYYY_MM_DD) : null)
        setPrevDischargeTime(lastHospital?.dischargeAt ? new Date(lastHospital?.dischargeAt).toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }) : "")
      }
    }
  }, [hospitalizationDetails])

  const getDistrictData = (hospiData) => {
    if (hospiData) {      
      const dids = hospiData.map(item => item.districtId);
      const payload = {
        districtId: dids
      }
      axiosRequest().post(`${REACT_APP_KSHEMA_POC1}/iagri-fa-be/masters/villageData`, payload).then(async data => {
        setDistrictsList(data?.data?.response?.districts)
      }).catch(error => {
        console.error(error)
        toast.error("Something Went Wrong.")
      })
    }
  }

  const [patientDetails, setPatientDetails] = useState({})
  useEffect(() => {
    if (claimDetails?.memberId && policyData) {
      const member = getPolicyMembers(policyData)?.find(member => member.member_id === claimDetails?.memberId)
      setPatientDetails(member)
    }

  }, [claimDetails, policyData])

  useEffect(() => {
    setHospitalizationDetails(claimDetails?.hospitalizationDetailsList)
    getDistrictData(claimDetails?.hospitalizationDetailsList)
    getVillages(claimDetails?.hospitalizationDetailsList)

  }, [claimDetails])

  const setValue = (key, value) => {
    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleEditClick = (record) => {
    setIsDisabled(true)
    setFormData((prev) => ({
      ...prev,
      hospitalizationDetails: [{
        [FORM_KEYS.time_of_admission]: record?.admissionAt ? new Date(record?.admissionAt).toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }) : "",
        [FORM_KEYS.date_of_discharge]: record?.dischargeAt ? format(new Date(record?.dischargeAt), DATE_FORMAT.YYYY_MM_DD) : null,
        [FORM_KEYS.time_of_discharge]: record?.dischargeAt ? new Date(record?.dischargeAt).toLocaleTimeString('en-US', {
          hour: '2-digit',
          minute: '2-digit',
          hour12: false
        }) : "",
        [FORM_KEYS.date_of_admission]: record?.admissionAt ? format(new Date(record?.admissionAt), DATE_FORMAT.YYYY_MM_DD) : null,
        [FORM_KEYS.pincode]: record?.hospitalCityPincode,
        [FORM_KEYS.state]: {label:record?.stateName,value:record?.stateId},
        [FORM_KEYS.district]: {label:record?.location?.districtName,value:record?.districtId},
        [FORM_KEYS.mandal]: {label:record?.location?.mandalName, value:record?.mandalId},
        [FORM_KEYS.village]: {label:record?.location?.villageName,value:record?.villageId},
        [FORM_KEYS.hospital]: {label:record?.hospitalName ||record.hospital,value:record?.hospitalName ||record.hospital},
        [FORM_KEYS.hospital_name]: record?.hospitalName,
        [FORM_KEYS.hospital_city_and_pincode]: record?.hospitalCityPincode,
        [FORM_KEYS.icu_days]: record?.numberOfDaysInICU,
        [FORM_KEYS.non_icu_days]: record?.numberOfDaysInNonICU,
        [FORM_KEYS.doctor_name]: record?.doctorName,
        [FORM_KEYS.doctor_mobile_number]: record?.doctorMobileNumber,
        [FORM_KEYS.doctor_registration_number]: record?.doctorRegistrationNumber,
        [FORM_KEYS.reason_of_hospitalization]:hospitalizationReasons.filter((data)=>record?.reason?.includes(data.label)),
        [FORM_KEYS.ailment]: ailmentList?.filter((data)=>record?.ailments.includes(data.label)),
        [FORM_KEYS.description_of_diagnosis]: record?.diagnosisDesp,
        hospitalizationId: record?.hospitalId
      }]
    }));
    setShowAddModal(true);
  };

  const shouldShowAddHospital = () => {
    if (hospitalizationDetails?.length) {
      let canShow = true
      hospitalizationDetails?.map(hospital => {
        if(!hospital.dischargeAt) {
          canShow = false
        }
      })
      return canShow
    } else return true
  }


  const addHospitalizationDetails = (hospitalIndex, key, value) => {
    setFormData((prev) => {
      return {
        ...prev,
        hospitalizationDetails: prev.hospitalizationDetails?.map((item, index) =>
          index === hospitalIndex ? { ...item, [key]: value } : item
        ),
      };
    });
  };

  const handleAddHospital = async () => {
    const payload = {
      claimId: claimId,
      hospitalName:formData?.hospitalizationDetails[0]?.hospital_name || formData?.hospitalizationDetails[0]?.hospital.value.hospitalName,
      districtId: formData?.hospitalizationDetails[0]?.hospital?.value?.did || formData?.hospitalizationDetails[0]?.district?.value,
      stateId: formData?.hospitalizationDetails[0]?.hospital?.value?.sid || formData?.hospitalizationDetails[0]?.state?.value,
      stateName:formData?.hospitalizationDetails[0]?.state?.label,
      hospitalCityPincode: formData?.hospitalizationDetails[0]?.pincode,
      admissionAt: formData?.hospitalizationDetails[0]?.date_of_admission ? formData?.hospitalizationDetails[0]?.date_of_admission + "T" + formData?.hospitalizationDetails[0]?.time_of_admission + ":" + "00+05:30" : "",
      dischargeAt: formData?.hospitalizationDetails[0]?.date_of_discharge ? formData?.hospitalizationDetails[0]?.date_of_discharge + "T" + formData?.hospitalizationDetails[0]?.time_of_discharge + ":" + "00+05:30" : "",
      totalDaysStay: Number(formData?.hospitalizationDetails[0]?.icu_days || 0) + Number(formData?.hospitalizationDetails[0]?.non_icu_days || 0),
      doctorName: formData?.hospitalizationDetails[0]?.doctor_name,
      doctorMobileNumber: formData?.hospitalizationDetails[0]?.doctor_mobile_number,
      doctorRegistrationNumber: formData?.hospitalizationDetails[0]?.doctor_registration_number,
      diagnosisDesp: formData?.hospitalizationDetails[0]?.description_of_diagnosis,
      ailments: formData?.hospitalizationDetails[0]?.ailment?.map(item => item.value),
      numberOfDaysInICU: formData?.hospitalizationDetails[0]?.icu_days,
      numberOfDaysInNonICU: formData?.hospitalizationDetails[0]?.non_icu_days,
      hospitalizationId: formData?.hospitalizationDetails[0]?.hospitalizationId ? formData?.hospitalizationDetails[0]?.hospitalizationId :"",
      mandalId:formData?.hospitalizationDetails[0]?.hospital?.value?.mid || formData?.hospitalizationDetails[0]?.mandal?.value,
      villageId:formData?.hospitalizationDetails[0]?.hospital?.value?.vid || formData?.hospitalizationDetails[0]?.village?.value,
      reasonId:formData?.hospitalizationDetails[0]?.reason_of_hospitalization?.value || formData?.hospitalizationDetails[0]?.reason_of_hospitalization?.[0]?.value
    }
    setLoading(true);
    axiosRequest().post(`${REACT_APP_VAM_ENDPOINT}/${HEALTH_CLAIM_INGESTION}/hospitalization-records`, payload).then(async data => {      
      toast.success(`Hospital ${isDisabled ? 'updated' : 'added'} successfully.`);
      if(data?.data) {
        await getClaimDetails(claimId)
      }
    }).catch(error => {
      console.error(error)
      toast.error("Something Went Wrong.")
    }).finally(() => {
      setLoading(false)
    })
    setFormData(defaultValues)
    setShowAddModal(false)
  }

  return (
    <>
      {loading && <LoadingPage kshemaLoader/>}
      <div className="claim-processing-tabs">
          <Accordion defaultActiveKey={["0", "1"]} alwaysOpen>
            {/* Claim Details Accordion */}
            <Accordion.Item eventKey="0">
              <Accordion.Header>Claim Details</Accordion.Header>
              <Accordion.Body>
                <div className="details1Individual">
                  <h6 className="sub-heading">Patient Details</h6>
                  <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Patient Name</p>
                      <div className="align1_dataIndividual">
                        {claimDetailCookie?.name ? claimDetailCookie?.name : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Patient Relationship</p>
                      <div className="align1_dataIndividual">
                        {patientDetails?.relation}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">DOB | Age</p>
                      <div className="align1_dataIndividual">{`${claimDetailCookie?.dateOfBirth ? format(new Date(claimDetailCookie?.dateOfBirth), DATE_FORMAT.DD_MM_YYYY) : "--"
                        } | ${claimDetailCookie?.dateOfBirth ? getAge(format(new Date(claimDetailCookie?.dateOfBirth), DATE_FORMAT.DD_MM_YYYY)) : "--"}`}</div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Gender</p>
                      <div className="align1_dataIndividual">
                        {claimDetailCookie?.gender ? claimDetailCookie?.gender : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Member ID</p>
                      <div className="align1_dataIndividual">
                        {claimDetailCookie?.memberId ? claimDetailCookie.memberId : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Alternate Mob no</p>
                      <div className="align1_dataIndividual">
                        {claimDetailCookie?.alternateMobileNumber ? claimDetailCookie?.alternateMobileNumber : "--"}
                      </div>
                    </div>
                    {/* <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">
                        Reason for Hospitalisation
                      </p>
                      <div className="align1_dataIndividual">
                        {reasonForHospitalisation
                          ? reasonForHospitalisation
                          : "--"}
                      </div> 
                    </div> */}
                  </div>
                </div>
                <hr />
                {/* Hospitalisation Details Section */}
                <div className="details1Individual"> 
                <div className="d-flex justify-content-between align-items-center">
                    <h6 className="sub-heading">Hospitalization Details</h6>
                    {editModeOn(functionalities.INTIMATION_SUMMARY_TAB) && showAddHospital && getIsShowButton(claimBasicDetails?.subStatus) &&
                      <button
                        className="btn btn-sm btn-primary mb-2 px-2"
                        onClick={() => {
                          setIsDisabled(false);
                          setShowAddModal(true);
                        }}
                      >
                        Add New Hospital
                      </button>
                    }
                  </div>
                  <div>
                    {hospitalizationDetails &&
                      hospitalizationDetails.length > 0 ? (
                      <div>
                        <div className="overflowHistory1">
                          <Table striped bordered responsive className="mt-0">
                            <thead>
                              <tr>
                                <th>Sl No.</th>
                                <th>Hospital Name</th>
                                <th>Hospital Location</th>
                                <th>Date of Admission</th>
                                <th>Date of Discharge</th>
                                <th>ICU Days</th>
                                <th>Non-ICU Days</th>
                                <th>Total Days</th>
                                <th>Doctor's Name</th>
                                <th>Doctor's Mob no</th>
                                <th>Doctor's Registration No</th>
                                <th>Reason for Hospitalization</th>
                                <th>Ailment</th>
                                <th>Description of Diagnosis</th>
                                {editModeOn(functionalities.INTIMATION_SUMMARY_TAB) && getIsShowButton(claimBasicDetails?.subStatus) && <th>Action</th>}
                              </tr>
                            </thead>
                            <tbody>
                              {hospitalizationDetails.map(
                                (item, index) => (
                                  <tr key={index}>
                                    <td>{index + 1}</td>
                                    <td>
                                      {item.hospitalName
                                        ? item.hospitalName
                                        : "--"}
                                    </td>
                                    <td>
                                      {`${
                                        item.location
                                          ? item.location?.villageName +", "+item.location?.mandalName+", "+item.location?.districtName
                                          : "--"
                                      }` +
                                        `${
                                          item.stateName
                                            ? `, ${item?.stateName}`
                                            : ""
                                        }` +
                                        `${
                                          item.hospitalCityPincode
                                            ? `, ${item?.hospitalCityPincode}`
                                            : ""
                                        }`}
                                    </td>
                                    <td>
                                      {item?.admissionAt
                                        ?format(new Date(item?.admissionAt), 'dd-MM-yyyy, hh:mm a')
                                        : "--"}
                                    </td>
                                    <td>
                                      {item.dischargeAt
                                        ? format(new Date(item?.dischargeAt), 'dd-MM-yyyy, hh:mm a')
                                        : "--"}
                                    </td>
                                    <td>
                                      {item?.numberOfDaysInICU ? item.numberOfDaysInICU : "--"}
                                    </td>
                                    <td>
                                      {item?.numberOfDaysInNonICU ? item.numberOfDaysInNonICU : "--"}
                                    </td>
                                    <td>
                                      {item?.numberOfDaysInICU || item?.numberOfDaysInNonICU ? +(item?.numberOfDaysInICU) + +(item?.numberOfDaysInNonICU) : "--"}
                                    </td>
                                    <td>
                                      {item.doctorName
                                        ? item.doctorName
                                        : "--"}
                                    </td>
                                    <td>
                                      {item.doctorMobileNumber
                                        ? item.doctorMobileNumber
                                        : "--"}
                                    </td>
                                    <td>
                                      {item.doctorRegistrationNumber
                                        ? item.doctorRegistrationNumber
                                        : "--"}
                                    </td>
                                    <td>{item?.reason}</td>
                                    <td>
                                      {item.ailments && item.ailments.length > 0 ? (
                                        item.ailments.map((ailment, index) => (
                                          <p key={index}>{ailment}</p>
                                        ))
                                      ) : (
                                        "--"
                                      )}
                                    </td>
                                    <td>
                                      <TextTruncate
                                        text={
                                          item.diagnosisDesp
                                            ? item.diagnosisDesp
                                            : "--"
                                        }
                                        length={50}
                                      />
                                    </td>
                                    {editModeOn(functionalities.INTIMATION_SUMMARY_TAB) &&
                                      <td
                                        className={`${item?.dischargeAt ? "" : "tableButtonBg1"}`}
                                        onClick={() => {
                                          if (item?.dischargeAt) return;
                                          handleEditClick(item)
                                        }}
                                      >
                                        {!item?.dischargeAt ? (
                                          <FontAwesomeIcon
                                            icon="fas fa-edit"
                                            className="edit_button"
                                          />
                                        ) : "-"}
                                      </td>}

                                  </tr>
                                )
                              )}
                            </tbody>
                          </Table>
                        </div>
                      </div>
                    ) : (
                      <div className="text-center">
                        No Hospitalisation Details Found
                      </div>
                    )}
                  </div>
                </div>
                <hr />
                <div className="details1Individual">
                  <h6 className="sub-heading">Additional Fields</h6>
                  <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Intimated Date & Time</p>
                      <div className="align1_dataIndividual">
                        {claimDetailCookie?.intimationAt ? format(new Date(claimDetailCookie?.intimationAt), 'dd-MM-yyyy, hh:mm a') : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Source</p>
                      <div className="align1_dataIndividual">
                        {getChannelName(claimDetailCookie?.channelId)}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Total Claims Raised</p>
                      <div className="align1_dataIndividual">
                        {claimDetailCookie.count ? claimDetailCookie.count : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Attached Files</p>
                      <div className="align1_dataIndividual">
                        <span
                          className="text-success cursor-pointer text-decoration-underline"
                          onClick={() => { 
                            navigate('.', {
                              state: {
                                ...location.state,
                                activeTab: PAGE_NAME_KEYS.DOCUMENTS,
                              },
                              replace: true,
                            });
                          }}
                        >
                          <TextTruncate text={'Click to view files'} length={23} />
                        </span>
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Letters</p>
                      <div className="align1_dataIndividual">
                        {letters ? letters : "--"}
                      </div>
                    </div>
                    {/* <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Proposal ID</p>
                      <div className="align1_dataIndividual">
                        {proposalId ? proposalId : "--"}
                      </div>
                    </div> */}
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Claim Remarks</p>
                      <div className="align1_dataIndividual">
                        {claimDetailCookie?.remarks ? claimDetailCookie?.remarks : "--"}
                      </div>
                    </div>
                    {/* <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Claim Warning</p>
                      <div className="align1_dataIndividual">
                        {claimWarning ? claimWarning : "--"}
                      </div>
                    </div> */}
                  </div>
                </div>
                <hr />
                <div className="details1Individual">
                  <h6 className="sub-heading">Claim Intimator Details</h6>
                  <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Claim Intimated By</p>
                      <div className="align1_dataIndividual">
                        {claimDetailCookie?.claimIntimationType ? claimDetailCookie.claimIntimationType : "--"}
                      </div>
                    </div>
                    {claimDetailCookie?.claimIntimationType !== "Self" && (
                      <>
                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                          <p className="align1Individual">Intimator's Name</p>
                          <div className="align1_dataIndividual">
                            {claimDetailCookie?.intimatorName ? claimDetailCookie?.intimatorName : "--"}
                          </div>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                          <p className="align1Individual">
                            Relationship with Policy Holder
                          </p>
                          <div className="align1_dataIndividual">
                            {claimDetailCookie?.relationshipToPolicyholder
                              ? claimDetailCookie?.relationshipToPolicyholder
                              : "--"}
                          </div>
                        </div>
                      </>
                    )}
                  </div>
                </div>
                {/* <hr />
                <div className="details1Individual">
                  <h6 className="sub-heading">Additional Remarks</h6>
                  <div>
                    <div className="additional_remarks_individual">
                      {additionalRemarks ? additionalRemarks : "--"}
                    </div>
                  </div>
                </div> */}
              </Accordion.Body>
            </Accordion.Item>

            <Modal show={showAddModal} onHide={() => { setFormData(defaultValues); setShowAddModal(false) }} size="xl">
              <ModalHeader closeButton>
                <Modal.Title>{isDisabled ? "Edit" : "ADD"} Hospitalization Details</Modal.Title>
              </ModalHeader>
              <ModalBody>
                <HospitalizationDetails
                  formData={formData}
                  setValue={setValue}
                  setHospitalizationDetails={addHospitalizationDetails}
                  isIncident={true}
                  setFormData={setFormData}
                  defaultHospitalizationDetails={defaultHospitalizationDetails}
                  hospitalizationReasons={hospitalizationReasons}
                  ailmentList={ailmentList}
                  isDisabled={isDisabled}
                  statesList={statesList}
                  isSubmit={true}
                  previousHospitalDischargeDate={prevDischargeDate}
                  previousHospitalDischargeTime={prevDischargeTime}
                  handleAddEditHospital={handleAddHospital}
                />
              </ModalBody>
            </Modal>

            {/* Policy Details Accordion */}
            <Accordion.Item eventKey="1">
              <Accordion.Header>Policy Details</Accordion.Header>
              <Accordion.Body>
                <div className="details1Individual">
                  <h6 className="sub-heading">Insured Details</h6>
                  <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Customer / Member ID</p>
                      <div className="align1_dataIndividual">
                        {patientDetails?.member_id || "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Policy Holder Name</p>
                      <div className="align1_dataIndividual">
                        {patientDetails?.name || "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Date of Birth</p>
                      <div className="align1_dataIndividual">
                        {patientDetails?.dob ? format(new Date(patientDetails?.dob), DATE_FORMAT.DD_MM_YYYY) : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Gender</p>
                      <div className="align1_dataIndividual">
                        {patientDetails?.gender || "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Policy Holder PED (Pre Existing Disease)</p>
                      <div className="align1_dataIndividual">
                        {patientDetails && patientDetails?.diseases && patientDetails?.diseases?.length > 0 ? patientDetails?.diseases?.map((item)=>item.name)?.join(", "):""}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Mobile Number</p>
                      <div className="align1_dataIndividual">
                        {customer_mobile ? customer_mobile : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">CKYC</p>
                      <div className="align1_dataIndividual">
                        {ckyc_kin_number ? ckyc_kin_number : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">State</p>
                      <div className="align1_dataIndividual">
                        {communication_state ? communication_state : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">District</p>
                      <div className="align1_dataIndividual">
                        {communication_district ? communication_district : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Mandal</p>
                      <div className="align1_dataIndividual">
                        {communication_mandal ? communication_mandal : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">City/ Town / Village</p>
                      <div className="align1_dataIndividual">
                        {communication_village ? communication_village : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Pin Code</p>
                      <div className="align1_dataIndividual">
                        {communication_pincode ? communication_pincode : "--"}
                      </div>
                    </div>
                  </div>
                </div>
                <hr />
                <div className="claim-intimation-detail">
                  {loading ? (
                    <p><LoadingPage /></p>
                  ) : policyData ? (
                    <MemberDetails policyData={policyData} />
                  ) : (
                    <p className="text-danger">Policy Data not available</p>
                  )}
                </div>
                <hr />
                <div className="details1Individual">
                  <h6 className="sub-heading">Subject Matter Details</h6>
                  <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Product Name</p>
                      <div className="align1_dataIndividual">
                        {product_name ? product_name : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Policy Number</p>
                      <div className="align1_dataIndividual">
                        {policyId ? policyId : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Sum Insured (₹)</p>
                      <div className="align1_dataIndividual">
                        {patientDetails?.sumInsured && insured_days ? + (patientDetails?.sumInsured) * +(insured_days) : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Premium Excl GST (₹)</p>
                      <div className="align1_dataIndividual">
                        {base_premium ? parseFloat(base_premium).toFixed(2) : "--"}
                      </div>
                    </div>
                    {igst ? (
                      <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                        <p className="align1Individual">IGST (₹)</p>
                        <div className="align1_dataIndividual">{igst}</div>
                      </div>
                    ) : (
                      <>
                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                          <p className="align1Individual">CGST (₹)</p>
                          <div className="align1_dataIndividual">{cgst ? cgst : "--"}</div>
                        </div>
                        <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                          <p className="align1Individual">SGST (₹)</p>
                          <div className="align1_dataIndividual">{sgst ? sgst : "--"}</div>
                        </div>
                      </>
                    )}
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Premium Incl GST (₹)</p>
                      <div className="align1_dataIndividual">
                        {total_premium ? parseFloat(total_premium).toFixed(2) : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Policy Start Date</p>
                      <div className="align1_dataIndividual">
                        {policy_start_date ? format(new Date(policy_start_date), DATE_FORMAT.DD_MM_YYYY) : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Policy End Date</p>
                      <div className="align1_dataIndividual">
                        {policy_end_date ? format(new Date(policy_end_date), DATE_FORMAT.DD_MM_YYYY) : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Policy Status</p>
                      <div className="align1_dataIndividual">
                        {getHealthPolicyStatus(claimBasicDetails?.policyStatus) || "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Policy Type</p>
                      <div className="align1_dataIndividual">
                        {policy_type ? policy_type : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Endorsement Number</p>
                      <div className="align1_dataIndividual">
                        {endorsementNumber ? endorsementNumber : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Add on Covers</p>
                      <div className="align1_dataIndividual">
                        {patientDetails?.optionalcovers?.length ? patientDetails?.optionalcovers?.join(", ") : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Insured Days</p>
                      <div className="align1_dataIndividual">
                        {insured_days ? insured_days : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Base Amount/ per day (₹)</p>
                      <div className="align1_dataIndividual">
                        {patientDetails?.sumInsured || "--"}
                      </div>
                    </div>
                    {/* <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                        <p className="align1Individual">Policy Document</p>
                        <div className="align1_dataIndividual">
                            <a href={`/documents/${policy_doc_id}`} target="_blank" rel="noopener noreferrer">
                            {policy_doc_id ? "View Document" : "--"}
                            </a>
                        </div>
                        </div> */}
                  </div>
                </div>
                {/* <hr />
                <div className="details1Individual">
                  <h6 className="sub-heading">Bank Details</h6>
                  <div className="row">
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Bank Name</p>
                      <div className="align1_dataIndividual">
                        {bank_name ? bank_name : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">Account no</p>
                      <div className="align1_dataIndividual">
                        {account_number ? account_number : "--"}
                      </div>
                    </div>
                    <div className="col-xl-3 col-lg-3 col-md-4 col-sm-6">
                      <p className="align1Individual">IFSC Code</p>
                      <div className="align1_dataIndividual">
                        {ifsc_code ? ifsc_code : "--"}
                      </div>
                    </div>
                  </div>
                </div> */}
              </Accordion.Body>
            </Accordion.Item>
          </Accordion>
        </div>
      {/* </div> */}
    </>
  );
};

export default ClaimIntimationDetail;
